const matomoID = "163"
const matomoURL = "https://matomo.boyens-medien.de/matomo.php";

export const trackMatomoBrowsing = (fromurl, userType) => {
  userType = "Digital+";
  const customDimensionId = 1;
  const url = new URL(matomoURL);
  const params = {
    idsite: matomoID,
    rec: 1,
    url: fromurl,
    rand: Math.random().toString(),
    [`dimension${customDimensionId}`]: userType,
  };
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });
  //console.log("Matomo tracking URL:", url.toString());
  fetch(url.toString(), { method: "GET" })
    .then((response) => {
      if (response.ok) {
        //console.log("Matomo event successfully tracked", response);
      } else {
        console.error("Matomo tracking failed:", response.statusText);
      }
    })
    .catch((error) => {
      console.error("Matomo tracking error:", error);
    });
};
export const trackMatomoNotificationEntry = (category, action, name, userType) => {
  userType = "Digital+";
  const customDimensionId = 1;
  const url = new URL(matomoURL);
  const params = {
    idsite: matomoID,
    rec: 1,
    action_name: `${category}/${action}/${name}`,
    e_c: `${category}`,
    e_a: `${action}`,
    e_n: `${name}`,
    rand: Math.random().toString(),
    [`dimension${customDimensionId}`]: userType,
  }
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });
  //console.log("Matomo tracking URL:", url.toString());
  fetch(url.toString(), { method: "GET" })
    .then((response) => {
      if (response.ok) {
        //console.log("Matomo event successfully tracked", response);
      } else {
        console.error("Matomo tracking failed:", response.statusText);
      }
    })
    .catch((error) => {
      console.error("Matomo tracking error:", error);
    });
}

export const trackMatomoInterstitial = (category, action, name, userType) => {
  if (userType == null) {
    userType = "ohneLogin"
  }
  const url = new URL("https://matomo.boyens-medien.de/matomo.php");
  const params = {
    idsite: matomoID,
    rec: 1,
    action_name: `${category}/${action}/${name}`,
    e_c: `${category}`,
    e_a: `${action}`,
    e_n: `${name}`,
    cvar: JSON.stringify({
      "1": ["UserType", userType, "visit"]
    }),
    //e_v: `${value}`,  // Event value (e.g., page number)
    rand: Math.random().toString(),
  };
  //console.log(`${params.action_name}`)
  //console.log(`${params.cvar}`)
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  fetch(url, {
    method: 'GET',
  })
    .then(response => {
      if (response.ok) {
        //console.log(url);
        //console.log('Matomo interstitial successfully tracked');
      } else {
        console.error('Matomo tracking failed:', response.statusText);
      }
    })
    .catch(error => {
      console.error('Matomo tracking error:', error);
    });
};